import { adalApiFetch } from "authProvider";
import { endPoints, API_ROOT } from "appSettings";

export const getProductRolesAccessOptions = (productId: number) => {
  return (dispatch: any) => {
    return adalApiFetch(
      fetch,
      `${API_ROOT}${endPoints.productRoles}/${productId}/permissions`,
      {
        method: "GET",
        headers: {
          "content-type": "application/json",
        },
      },
      dispatch
    ).then((response: any) => response.json());
  };
};

export const getProductOptions = (roleNameId: string) => {
  return (dispatch: any) => {
    return adalApiFetch(
      fetch,
      `${API_ROOT}${endPoints.authorization}/role-names/${roleNameId}/products`,
      {
        method: "GET",
        headers: {
          "content-type": "application/json",
        },
      },
      dispatch
    ).then((response: any) => response.json());
  };
};

export const getProductRolesAccess = (email: string, productId: number) => {
  return (dispatch: any) => {
    return adalApiFetch(
      fetch,
      `${API_ROOT}${endPoints.user}/${email}/products/${productId}/role-accesses`,
      {
        method: "GET",
        headers: {
          "content-type": "application/json",
        },
      },
      dispatch
    ).then((response: any) => response.json());
  };
};

export const updateProductRolesAccess = (
  email: string,
  productId: number,
  data: { productRoleAccessIds: string[] }
) => {
  return (dispatch: any) => {
    return adalApiFetch(
      fetch,
      `${API_ROOT}${endPoints.user}/${email}/products/${productId}/role-accesses`,
      {
        method: "PUT",
        headers: {
          "content-type": "application/json",
        },
        body: JSON.stringify(data),
      },
      dispatch
    ).then((response: any) => {
      if (!response.ok) {
        return false;
      }
      return true;
    });
  };
};
